import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ResumeSamplePage } from './resume-sample.page';

const routes: Routes = [
  {
    path: '',
    component: ResumeSamplePage
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResumeSamplePageRoutingModule {}
